import axios from 'axios';
import AlertDialog from '@global/helpers/alertDialog';
import utmKDetect from '@global/helpers/utmKDetect';
import gtmTrace from '@global/components/tracing/gtm';
import $ from 'jquery';
import { btnDescriptionEnum, btnFoodDescriptionEnum, btnStyleEnum } from '@/models/productEnum';
import { fireShopContentView } from '@global/gtm/product';
import { fireAddToCart } from '@global/gtm/common';
import fireWishlistEvent from '@global/gtm/wishlist';

const shopContent = {
  namespaced: true,
  state: {
    itemDatas: {},
    // 尺寸
    selectedSpecID: null,
    // 顏色
    selectedDataID: null,
    selectedData: {},
    recommendData: {},
    brandRecommendData: {},
    dataIsLoad: false,
    rDataIsLoad: false,
    CMID: null,
    utmData: '',
    selectedSpec: { Name: '尺寸', Key: 'default', ID: 'default' },
    selectedSpecKey: null,
    counter: 1,
    btnStyleGenerate: btnStyleEnum.disabled,
    btnDescriptionGenerate: btnDescriptionEnum.general,
    pzBuyNow: btnDescriptionEnum.general,
    selectIsOpen: false,
    userSelectFlavor: null,
    selectedFoodSpec: null,
    foodBtnStyle: btnStyleEnum.disabled,
    foodBtnDescription: btnFoodDescriptionEnum.general,
    pattern: window.Pattern,
    isOpenCartDialog: false,
    isOpenStockDialog: false,
    foodAddonID: window.CustomMarketID
      ? window.CustomMarketID.substring(0, window.CustomMarketID.indexOf('CL'))
      : null,
  },
  mutations: {
    setItemData(state, val) {
      state.itemDatas = val;
      if (state.pattern !== 2) state.selectedDataID = val.ColorID;
    },
    randomSlideArray(state, arr) {
      let ctr = arr.length;
      let temp;
      let index;

      while (ctr > 0) {
        index = Math.floor(Math.random() * ctr);
        ctr -= 1;
        temp = arr[ctr];
        arr[ctr] = arr[index];
        arr[index] = temp;
      }
      state.recommendData = arr;
    },
    changeSelected(state, val) {
      state.selectedDataID = val;
    },
    handleCustomMarketID(state, val) {
      state.CMID = val;
    },
    /**
     * @description 取得 user 選擇的口味和規格
     * @param {boolean} type - 是否為 user 手動變更口味，若否則預設點擊商品的口味
     */
    setSelectedFood(state, payload) {
      if (payload.type === false) {
        state.userSelectFlavor = payload.foodFlavors.find((flavor) => flavor.Selected);
        state.selectedFoodSpec = state.userSelectFlavor.Specs.find((spec) => spec.Selected);
      } else {
        const checkHasStock = state.userSelectFlavor.Specs.find((stock) => stock.Stock > 0);

        if (checkHasStock) {
          state.selectedFoodSpec = checkHasStock;
        } else {
          const { Specs } = state.userSelectFlavor;
          const [selectedFoodSpec] = Specs;

          state.selectedFoodSpec = selectedFoodSpec;
        }
      }
    },
    addCount(state, payload) {
      // 還沒選尺寸或是即將開賣
      if (state.pattern !== 2 && state.selectedSpec.Key === 'default') return;
      if (state.pattern !== 2 && state.itemDatas.IsPreShow) return;
      if (state.pattern === 2 && state.selectedFoodSpec.Product.IsPreShow) return;
      if (state.counter >= payload.maxCount) return;
      if (state.counter >= payload.limit && payload.limit !== 0) return;
      state.counter += 1;
    },
    reduceCount(state) {
      if (state.counter <= 1) return;
      state.counter -= 1;
    },
    resetCounter(state) {
      state.counter = 1;
    },
    foodBtnStyleGenerate(state) {
      if (state.selectedFoodSpec.Product.IsPreShow) {
        state.foodBtnStyle = btnStyleEnum.disabled;
        state.foodBtnDescription = btnFoodDescriptionEnum.preShow;
        return;
      }
      if (
        state.selectedFoodSpec.Stock === 0 &&
        state.selectedFoodSpec.Product.IsOutOfStock &&
        !state.selectedFoodSpec.Product.PreOrder
      ) {
        // 無庫存且斷貨但是為現貨
        state.foodBtnStyle = btnStyleEnum.disabled;
        state.foodBtnDescription = btnFoodDescriptionEnum.soldOut;
      } else if (state.selectedFoodSpec.Stock === 0) {
        state.foodBtnStyle = btnStyleEnum.activeMail;
        state.foodBtnDescription = btnFoodDescriptionEnum.notice;
      } else {
        state.foodBtnStyle = btnStyleEnum.active;
        state.foodBtnDescription = btnFoodDescriptionEnum.addBag;
      }
    },
    clearSpec(state) {
      state.selectedSpec = { Name: '尺寸', Key: 'default' };
      state.selectedSpecID = null;
      state.selectedSpecKey = null;
    },
    btnReset(state) {
      state.btnStyleGenerate = btnStyleEnum.disabled;
      state.btnDescriptionGenerate = btnDescriptionEnum.general;
      state.pzBuyNow = btnDescriptionEnum.general;
      if (state.itemDatas.IsPreShow) {
        state.btnDescriptionGenerate = btnDescriptionEnum.preShow;
        state.pzBuyNow = btnDescriptionEnum.preShow;
      }
    },
    openSelector(state) {
      state.selectIsOpen = !state.selectIsOpen;
    },
    showMobileCartDialog(state) {
      state.isOpenCartDialog = true;
    },
    showMobileStockDialog(state) {
      state.isOpenStockDialog = true;
    },
    closeMobileCartDialog(state) {
      state.isOpenCartDialog = false;
    },
    closeMobileStockDialog(state) {
      state.isOpenStockDialog = false;
    },
    getBtnStatus(state, payload) {
      if (state.itemDatas.IsPreShow) return;
      if (payload.stock === 0 && payload.isSoldOut && !payload.isPreOrder) {
        // 現貨無庫存且斷貨
        state.btnStyleGenerate = btnStyleEnum.disabled;
        state.btnDescriptionGenerate = btnDescriptionEnum.soldOut;
        state.pzBuyNow = btnDescriptionEnum.soldOut;
      } else if (payload.stock === 0) {
        // 無庫存
        state.btnStyleGenerate = btnStyleEnum.activeMail;
        state.btnDescriptionGenerate = btnDescriptionEnum.notice;
        state.pzBuyNow = btnDescriptionEnum.notice;
      } else {
        state.btnStyleGenerate = btnStyleEnum.active;
        state.btnDescriptionGenerate = btnDescriptionEnum.addBag;
        state.pzBuyNow = '立即結帳';
      }
    },
    changeFoodAddonID(state) {
      const originID = state.selectedFoodSpec.Product.CustomMarketID;
      state.foodAddonID = originID.substring(0, originID.indexOf('CL'));
    },
  },
  actions: {
    getData({ state, commit }) {
      state.dataIsLoad = false;

      if (state.pattern === 2) {
        axios
          .get(API_URL.SERIES_MARKET_CONTENT, {
            params: {
              MarketID: window.MarketID,
            },
          })
          .then((res) => {
            if (res.data.Code === 200) {
              commit('setItemData', res.data.Response);
              commit('setSelectedFood', { foodFlavors: res.data.Response.Flavors, type: false });
              commit('foodBtnStyleGenerate');
              commit('resetCounter');

              state.dataIsLoad = true;

              fireShopContentView({
                affiliation: state.userSelectFlavor.Name,
                item_brand: state.selectedFoodSpec.Name,
                customMarketID: state.selectedFoodSpec.Product.CustomMarketID,
                eventName: state.selectedFoodSpec.Product.Events.length
                  ? state.selectedFoodSpec.Product.Events[0].Name
                  : '',
                name: state.selectedFoodSpec.Product.Name,
                price: state.selectedFoodSpec.Product.SellPrice,
              });
            } else {
              AlertDialog.alert('系統忙線中,請稍後再試');
            }
          })
          .catch(() => {
            AlertDialog.alert('系統忙線中,請稍後再試');
          });
      } else {
        // pattern 為 1 和 3 都是一般賣場模式
        // pattern 為 3 為外部供應商自訂商品描述HTML
        axios
          .get(API_URL.MARKET_CONTENT, {
            params: {
              CustomMarketID: window.CustomMarketID,
            },
          })
          .then((res) => {
            if (res.data.Code === 200) {
              state.dataIsLoad = true;
              commit('setItemData', res.data.Response);
              if (state.itemDatas.IsPreShow) {
                state.btnStyleGenerate = btnStyleEnum.disabled;
                state.btnDescriptionGenerate = btnDescriptionEnum.preShow;
                state.pzBuyNow = btnDescriptionEnum.preShow;
              }
            } else {
              AlertDialog.alert('系統忙線中,請稍後再試');
            }
          })
          .catch(() => {
            AlertDialog.alert('系統忙線中,請稍後再試');
          });
      }
    },
    getSelectedData({ state, dispatch }) {
      state.selectedData = state.itemDatas.Colors.find(
        (color) => color.ID === state.selectedDataID,
      );

      if (state.selectedData.Specs.length === 1 && state.selectedData.Specs[0].Stock > 0) {
        dispatch('selectSpec', state.selectedData.Specs[0]);
      }
    },
    getRecommendData({ state, commit }) {
      axios
        .get(API_URL.MARKET_RECOMMAND, {
          params: {
            OnlyFirstColor: true,
            CategoryIDs: window.CategoryIDs.toString(),
            Page: 1,
            PageSize: 6,
          },
        })
        .then((res) => {
          if (res.data.Code === 200) {
            state.rDataIsLoad = true;
            commit('randomSlideArray', res.data.Response.Data);
          }
        })
        .catch(() => {
          AlertDialog.alert('系統忙線中,請稍後再試');
        });
    },
    addToCart({ state, dispatch, commit }) {
      const customMarketID = state.itemDatas.CustomMarketID;
      const subStringCustomMarketID = customMarketID.substring(0, customMarketID.indexOf('CL'));
      const itemSpecInfo = `${subStringCustomMarketID}CL${state.selectedData.ID}SZ${state.selectedSpecKey}`;

      commit('handleCustomMarketID', itemSpecInfo);

      if (
        state.selectedSpec.Stock === 0 &&
        state.selectedSpec.IsOutOfStock &&
        !state.selectedSpec.PreOrder
      ) {
        return;
      }
      if (state.selectedSpec.Stock === 0) {
        $('#lb-get-product-mail').modal('show');
        return;
      }

      return new Promise((resolve, reject) => {
        axios
          .post(API_URL.SHOPPING_CART, {
            CustomMarketID: itemSpecInfo,
            Count: state.counter,
            UtmTag: utmKDetect(itemSpecInfo) === null ? '' : utmKDetect(itemSpecInfo),
          })
          .then((res) => {
            if (res.data.Code === 200) {
              dispatch('miniCartModule/getCartInfo', '', { root: true });
              commit('closeMobileCartDialog');

              gtmTrace.addToCart({
                name: state.itemDatas.Name,
                id: itemSpecInfo,
                price: state.itemDatas.OriginPrice,
                sale_price:
                  state.itemDatas.EventPrice > 0 &&
                  state.itemDatas.EventPrice < state.itemDatas.SellPrice
                    ? state.itemDatas.EventPrice
                    : state.itemDatas.SellPrice,
                img_url: state.selectedData.Images[0].Url,
                product_url: state.selectedData.MarketUrl,
                color: state.selectedData.Name,
                count: state.counter,
              });

              fireAddToCart({
                item_id: itemSpecInfo.split('SZ')[0],
                item_name: state.itemDatas.Name,
                index: 0,
                affiliation: state.selectedData.Name,
                item_brand: state.selectedSpec.Name,
                item_list_name: '產品內頁',
                price:
                  state.itemDatas.EventPrice > 0 &&
                  state.itemDatas.EventPrice < state.itemDatas.SellPrice
                    ? state.itemDatas.EventPrice
                    : state.itemDatas.SellPrice,
                quantity: state.counter,
                item_variant: state.selectedSpec.Barcode,
              });

              resolve({ code: 200 });
            } else if (res.data.Code === 205) {
              resolve({ code: 205 });
            } else {
              resolve({ code: 400, response: res.data.Message });
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    foodAddToCart({ state, dispatch, commit }) {
      if (state.selectedFoodSpec === null) {
        AlertDialog.alert(btnFoodDescriptionEnum.general);
        return;
      }

      commit('handleCustomMarketID', state.selectedFoodSpec.Product.CustomMarketID);

      if (state.selectedFoodSpec.Stock === 0) {
        if (
          state.selectedFoodSpec.Product.IsOutOfStock &&
          !state.selectedFoodSpec.Product.PreOrder
        ) {
          return;
        }

        $('#lb-get-product-mail').modal('show');
        return;
      }

      const utmData =
        utmKDetect(state.selectedFoodSpec.Product.CustomMarketID) === null
          ? ''
          : utmKDetect(state.selectedFoodSpec.Product.CustomMarketID);

      return new Promise((resolve, reject) => {
        axios
          .post(API_URL.SHOPPING_CART, {
            CustomMarketID: state.selectedFoodSpec.Product.CustomMarketID,
            Count: state.counter,
            UtmTag: utmData,
          })
          .then((res) => {
            if (res.data.Code === 200 || res.data.Code === 406) {
              dispatch('miniCartModule/getCartInfo', '', { root: true });
              commit('closeMobileCartDialog');

              gtmTrace.addToCart({
                name: state.selectedFoodSpec.Product.Name,
                id: state.selectedFoodSpec.Product.CustomMarketID,
                price: state.selectedFoodSpec.Product.OriginPrice,
                sale_price:
                  state.selectedFoodSpec.Product.EventPrice > 0 &&
                  state.selectedFoodSpec.Product.EventPrice <
                    state.selectedFoodSpec.Product.SellPrice
                    ? state.selectedFoodSpec.Product.EventPrice
                    : state.selectedFoodSpec.Product.SellPrice,
                img_url: state.selectedFoodSpec.Product.Images[0].Url,
                product_url: state.selectedFoodSpec.Product.MarketUrl,
                color: state.userSelectFlavor.Name,
                count: state.counter,
              });

              fireAddToCart({
                item_id: state.selectedFoodSpec.Product.CustomMarketID.split('SZ')[0],
                item_name: state.selectedFoodSpec.Product.Name,
                index: 0,
                affiliation: state.userSelectFlavor.Name,
                item_brand: state.selectedFoodSpec.Name,
                item_list_name: '產品內頁',
                price: state.selectedFoodSpec.Product.SellPrice,
                quantity: state.counter,
                item_variant: '',
              });

              resolve({ code: 200 });
            } else if (res.data.Code === 205) {
              resolve({ code: 205 });
            } else {
              resolve({ code: 400, response: res.data.Message });
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    selectSpec({ state, commit }, spec) {
      if (spec.Key === 'default') {
        state.btnStyleGenerate = 'disabled';
        state.btnDescriptionGenerate = btnDescriptionEnum.general;
        state.pzBuyNow = btnDescriptionEnum.general;

        commit('clearSpec');
        commit('resetCounter');
        return;
      }

      state.selectedSpec = spec;
      state.selectedSpecID = spec.ID;
      state.selectedSpecKey = spec.Key;

      commit('resetCounter');
      commit('getBtnStatus', {
        stock: spec.Stock,
        isSoldOut: spec.IsOutOfStock,
        isPreOrder: spec.PreOrder,
      });
    },
    changeImg({ state, commit }, colorID) {
      state.selectIsOpen = false;
      if (state.selectedData.ID === colorID) return;

      commit('btnReset');
      commit('clearSpec');
      commit('resetCounter');
      commit('changeSelected', colorID);
    },
    changeFlavor({ state, commit }, flavorIndex) {
      if (state.itemDatas.Flavors[flavorIndex].Name === state.userSelectFlavor.Name) return;

      state.selectIsOpen = false;
      state.userSelectFlavor = state.itemDatas.Flavors[flavorIndex];

      commit('setSelectedFood', { foodFlavors: state.userSelectFlavor, type: true });
      commit('resetCounter');
      commit('foodBtnStyleGenerate');
      commit('changeFoodAddonID');

      fireShopContentView({
        affiliation: state.userSelectFlavor.Name,
        item_brand: state.selectedFoodSpec.Name,
        customMarketID: state.selectedFoodSpec.Product.CustomMarketID,
        eventName: state.selectedFoodSpec.Product.Events.length
          ? state.selectedFoodSpec.Product.Events[0].Name
          : '',
        name: state.selectedFoodSpec.Product.Name,
        price: state.selectedFoodSpec.Product.SellPrice,
      });
    },
    selectFoodSpec({ state, commit }, spec) {
      state.selectedFoodSpec = spec;

      commit('resetCounter');
      commit('foodBtnStyleGenerate');
      commit('changeFoodAddonID');

      fireShopContentView({
        affiliation: state.userSelectFlavor.Name,
        item_brand: state.selectedFoodSpec.Name,
        customMarketID: state.selectedFoodSpec.Product.CustomMarketID,
        eventName: state.selectedFoodSpec.Product.Events.length
          ? state.selectedFoodSpec.Product.Events[0].Name
          : '',
        name: state.selectedFoodSpec.Product.Name,
        price: state.selectedFoodSpec.Product.SellPrice,
      });
    },
    toggleFavorite({ state, getters }, isFavorite) {
      if (state.pattern === 2) {
        if (isFavorite) {
          axios
            .delete(API_URL.FAVORITE, {
              data: {
                CustomMarketID: getters.favCustomMarketID,
              },
            })
            .then((res) => {
              if (res.data.Code === 200) {
                if (res.data.Response) {
                  state.selectedFoodSpec.IsFavorite = false;
                  state.selectedFoodSpec.FavoriteAmount -= 1;
                }
              } else if (res.data.Code === 401) {
                AlertDialog.alert('請先登入');
              } else {
                AlertDialog.alert('系統忙線中');
              }
            })
            .catch((error) => {
              AlertDialog.alert(error);
            });
        } else {
          axios
            .post(API_URL.FAVORITE, {
              CustomMarketID: getters.favCustomMarketID,
            })
            .then((res) => {
              if (res.data.Code === 200) {
                if (res.data.Response) {
                  state.selectedFoodSpec.IsFavorite = true;
                  state.selectedFoodSpec.FavoriteAmount += 1;
                  fireWishlistEvent({
                    color: state.userSelectFlavor.Name,
                    id: getters.favCustomMarketID,
                    name: state.selectedFoodSpec.Product.Name,
                    sellPrice: state.selectedFoodSpec.Product.SellPrice,
                    size: state.selectedFoodSpec.Name || '',
                  });
                }
              } else if (res.data.Code === 401) {
                AlertDialog.alert('請先登入');
              } else {
                AlertDialog.alert('系統忙線中');
              }
            })
            .catch((error) => {
              AlertDialog.alert(error);
            });
        }
      } else {
        if (isFavorite) {
          axios
            .delete(API_URL.FAVORITE, {
              data: {
                CustomMarketID: getters.favCustomMarketID,
              },
            })
            .then((res) => {
              if (res.data.Code === 200) {
                if (res.data.Response) {
                  state.selectedData.IsFavorite = false;
                  state.selectedData.FavoriteCount -= 1;
                }
              } else if (res.data.Code === 401) {
                AlertDialog.alert('請先登入');
              } else {
                AlertDialog.alert('系統忙線中');
              }
            })
            .catch((error) => {
              AlertDialog.alert(error);
            });
        } else {
          axios
            .post(API_URL.FAVORITE, {
              CustomMarketID: getters.favCustomMarketID,
            })
            .then((res) => {
              if (res.data.Code === 200) {
                if (res.data.Response) {
                  state.selectedData.IsFavorite = true;
                  state.selectedData.FavoriteCount += 1;
                  fireWishlistEvent({
                    color: state.selectedData.Name,
                    id: getters.favCustomMarketID,
                    name: state.itemDatas.Name,
                    sellPrice: state.itemDatas.SellPrice,
                    size: state.selectedSpec.Name || '',
                  });
                }
              } else if (res.data.Code === 401) {
                AlertDialog.alert('請先登入');
              } else {
                AlertDialog.alert('系統忙線中');
              }
            })
            .catch((error) => {
              AlertDialog.alert(error);
            });
        }
      }
    },
  },
  getters: {
    favCustomMarketID(state) {
      if (state.pattern === 2) return state.selectedFoodSpec.Product.CustomMarketID;

      const substringID = state.itemDatas.CustomMarketID.substring(
        0,
        state.itemDatas.CustomMarketID.indexOf('CL'),
      );

      const customMarketID = `${substringID}CL${state.selectedData.ID}SZ_`;

      return customMarketID;
    },
  },
};

export default shopContent;
